// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-body {
    background-color: var(--footerColor);
    padding: 30px 0;
    display: flex;
    font-size: 14px;
    color: #6c757d;
}

.footer-logo-container {
    width: 40%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 20px;
    color: rgb(225, 232, 235);
    font-family: var(--paragraphFont);
    font-size: 36px;
    font-weight: 700;
    border-right: 1px solid #ccd4;
}

.footer-logo-img {
    width: 50px;
    height: 50px;
}

.footer-links-container {
    width: 60%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    gap: 20px;
    color: rgba(225, 232, 235, 0.526);
    font-family: var(--paragraphFont);
    font-size: 16px;
    padding: 10px 20px;
}

@media (max-width: 1000px) {
    .footer-body {
        padding-top: 0;
        padding-bottom: 0;
        flex-direction: column;
    }
    .footer-logo-container {
        width: 100%;
        margin: 0 auto;
        box-sizing: border-box;
        border-right: none;
        border-bottom: 1px solid #ccd4;
        font-size: 26px;
    }
    .footer-logo-img {
        width: 36px;
        height: 36px;
    }    
    .footer-links-container {
        width: 90%;
        margin: 0 auto;
        padding: 20px 0;
        align-items: flex-start;
        gap: 20px;
    }
    .footer-copyright {
        font-size: 10px !important;
    }
}

@media (max-width: 800px) {
	.footer-links-container {
		flex-direction: column;
		justify-content: center;
	}
	.footer-column {
		width: 100%;
	}

	.footer-column-title {
		font-size: 16px !important;
		border-bottom: 1px solid #ccd4;
		width: 100%;
		padding-bottom: 5px !important;
	}
	.footer-link {
		font-size: 18px !important;
	}
	.footer-copyright {
		font-size: 14px !important;
	}
	.footer-logo-container {
		border: none !important;
		background-color: var(--footerColorDark);
	}
}

.footer-column {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 100%;
    justify-content: flex-start;
    gap: 10px;
}

.footer-column-title {
    font-family: var(--displayFont);
    font-size: 12px;
    font-weight: 600;
    padding: 0;
    margin: 0;
}
.footer-link {
    color: rgba(229, 239, 242, 0.757);
    text-decoration: none;
    font-family: var(--paragraphFont);
    font-size: 14px;
}

.footer-copyright {
    background-color: var(--footerColorDark);
    color: rgba(225, 232, 235, 0.526);
    font-family: var(--paragraphFont);
    font-size: 12px;
    padding: 10px 0;
    display: flex;
    justify-content: center;
    align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/general/Footer.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,eAAe;IACf,aAAa;IACb,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,SAAS;IACT,iCAAiC;IACjC,iCAAiC;IACjC,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI;QACI,cAAc;QACd,iBAAiB;QACjB,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,cAAc;QACd,sBAAsB;QACtB,kBAAkB;QAClB,8BAA8B;QAC9B,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,UAAU;QACV,cAAc;QACd,eAAe;QACf,uBAAuB;QACvB,SAAS;IACb;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;CACC;EACC,sBAAsB;EACtB,uBAAuB;CACxB;CACA;EACC,WAAW;CACZ;;CAEA;EACC,0BAA0B;EAC1B,8BAA8B;EAC9B,WAAW;EACX,8BAA8B;CAC/B;CACA;EACC,0BAA0B;CAC3B;CACA;EACC,0BAA0B;CAC3B;CACA;EACC,uBAAuB;EACvB,wCAAwC;CACzC;AACD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;AACA;IACI,iCAAiC;IACjC,qBAAqB;IACrB,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,wCAAwC;IACxC,iCAAiC;IACjC,iCAAiC;IACjC,eAAe;IACf,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".footer-body {\n    background-color: var(--footerColor);\n    padding: 30px 0;\n    display: flex;\n    font-size: 14px;\n    color: #6c757d;\n}\n\n.footer-logo-container {\n    width: 40%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    padding: 20px;\n    color: rgb(225, 232, 235);\n    font-family: var(--paragraphFont);\n    font-size: 36px;\n    font-weight: 700;\n    border-right: 1px solid #ccd4;\n}\n\n.footer-logo-img {\n    width: 50px;\n    height: 50px;\n}\n\n.footer-links-container {\n    width: 60%;\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    gap: 20px;\n    color: rgba(225, 232, 235, 0.526);\n    font-family: var(--paragraphFont);\n    font-size: 16px;\n    padding: 10px 20px;\n}\n\n@media (max-width: 1000px) {\n    .footer-body {\n        padding-top: 0;\n        padding-bottom: 0;\n        flex-direction: column;\n    }\n    .footer-logo-container {\n        width: 100%;\n        margin: 0 auto;\n        box-sizing: border-box;\n        border-right: none;\n        border-bottom: 1px solid #ccd4;\n        font-size: 26px;\n    }\n    .footer-logo-img {\n        width: 36px;\n        height: 36px;\n    }    \n    .footer-links-container {\n        width: 90%;\n        margin: 0 auto;\n        padding: 20px 0;\n        align-items: flex-start;\n        gap: 20px;\n    }\n    .footer-copyright {\n        font-size: 10px !important;\n    }\n}\n\n@media (max-width: 800px) {\n\t.footer-links-container {\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t}\n\t.footer-column {\n\t\twidth: 100%;\n\t}\n\n\t.footer-column-title {\n\t\tfont-size: 16px !important;\n\t\tborder-bottom: 1px solid #ccd4;\n\t\twidth: 100%;\n\t\tpadding-bottom: 5px !important;\n\t}\n\t.footer-link {\n\t\tfont-size: 18px !important;\n\t}\n\t.footer-copyright {\n\t\tfont-size: 14px !important;\n\t}\n\t.footer-logo-container {\n\t\tborder: none !important;\n\t\tbackground-color: var(--footerColorDark);\n\t}\n}\n\n.footer-column {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    height: 100%;\n    justify-content: flex-start;\n    gap: 10px;\n}\n\n.footer-column-title {\n    font-family: var(--displayFont);\n    font-size: 12px;\n    font-weight: 600;\n    padding: 0;\n    margin: 0;\n}\n.footer-link {\n    color: rgba(229, 239, 242, 0.757);\n    text-decoration: none;\n    font-family: var(--paragraphFont);\n    font-size: 14px;\n}\n\n.footer-copyright {\n    background-color: var(--footerColorDark);\n    color: rgba(225, 232, 235, 0.526);\n    font-family: var(--paragraphFont);\n    font-size: 12px;\n    padding: 10px 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
